function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { FlagQualifier } from "../qualifiers/flag/FlagQualifier.js";
import { Qualifier } from "./qualifier/Qualifier.js";
import { mapToSortedArray } from "./utils/dataStructureUtils.js";
import { ActionModel } from "./models/ActionModel.js";
/**
 * @summary SDK
 * @memberOf SDK
 * @description Defines the category of transformation to perform.
 */

var Action = /*#__PURE__*/function (_ActionModel) {
  _inherits(Action, _ActionModel);

  var _super = _createSuper(Action);

  function Action() {
    var _this;

    _classCallCheck(this, Action);

    _this = _super.apply(this, arguments); // We're using map, to overwrite existing keys. for example:
    // addParam(w_100).addQualifier(w_200) should result in w_200. and not w_100,w_200

    _this.qualifiers = new Map(); // Unlike regular qualifiers, there can be multiple flags in each url component /fl_1,fl_2/
    // If the falgs are added to the qualifiers map, only a single flag could exist in a component (it's a map)
    // So flags are stored separately until the very end because of that reason

    _this.flags = [];
    _this.delimiter = ','; // {qualifier}{delimiter}{qualifier} for example: `${'w_100'}${','}${'c_fill'}`

    _this.actionTag = ''; // A custom name tag to identify this action in the future

    return _this;
  }

  _createClass(Action, [{
    key: "prepareQualifiers",
    value: function prepareQualifiers() {}
    /**
     * @description Returns the custom name tag that was given to this action
     * @return {string}
     */

  }, {
    key: "getActionTag",
    value: function getActionTag() {
      return this.actionTag;
    }
    /**
     * @description Sets the custom name tag for this action
     * @return {this}
     */

  }, {
    key: "setActionTag",
    value: function setActionTag(tag) {
      this.actionTag = tag;
      return this;
    }
    /**
     * @description Calls toString() on all child qualifiers (implicitly by using .join()).
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      this.prepareQualifiers();
      return mapToSortedArray(this.qualifiers, this.flags).join(this.delimiter);
    }
    /**
     * @description Adds the parameter to the action.
     * @param {SDK.Qualifier} qualifier
     * @return {this}
     */

  }, {
    key: "addQualifier",
    value: function addQualifier(qualifier) {
      // if string, find the key and value
      if (typeof qualifier === 'string') {
        var _qualifier$toLowerCas = qualifier.toLowerCase().split('_'),
            _qualifier$toLowerCas2 = _slicedToArray(_qualifier$toLowerCas, 2),
            key = _qualifier$toLowerCas2[0],
            value = _qualifier$toLowerCas2[1];

        if (key === 'fl') {
          // if string qualifier is a flag, store it in the flags arrays
          this.flags.push(new FlagQualifier(value));
        } else {
          // if the string qualifier is not a flag, create a new qualifier from it
          this.qualifiers.set(key, new Qualifier(key, value));
        }
      } else {
        // if a qualifier object, insert to the qualifiers map
        this.qualifiers.set(qualifier.key, qualifier);
      }

      return this;
    }
    /**
     * @description Adds a flag to the current action.
     * @param {Qualifiers.Flag} flag
     * @return {this}
     */

  }, {
    key: "addFlag",
    value: function addFlag(flag) {
      if (typeof flag === 'string') {
        this.flags.push(new FlagQualifier(flag));
      } else {
        if (flag instanceof FlagQualifier) {
          this.flags.push(flag);
        }
      }

      return this;
    }
  }, {
    key: "addValueToQualifier",
    value: function addValueToQualifier(qualifierKey, qualifierValue) {
      this.qualifiers.get(qualifierKey).addValue(qualifierValue);
      return this;
    }
  }]);

  return Action;
}(ActionModel);

export { Action };